import { call, put, takeLatest } from "redux-saga/effects";

// for toast
import { toast } from "react-toastify";
import { SpinnerDataActions } from "../../actionTypes/spinnerDataActionTypes";
import { getSpinnerDataApi } from "../requests/commonRequest";
import { setSpinnerData } from "../../actions/spinnerDataActions";


function* getSpinnerDataHandler() {
  try {
    const { data } = yield call(getSpinnerDataApi);
    if (data.status) {
      yield put(setSpinnerData(data?.data));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  }
}

export default function* spinnerDataSaga() {
  yield takeLatest(SpinnerDataActions.GET_SPINNER_DATA, getSpinnerDataHandler);
}
